<template>
  <v-container>
    <v-row dense align="center" justify="space-between">
      <v-col cols="auto">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>

      <v-col class="text-center">
        <div class="text-h4 font-weight-bold">
          <v-icon large color="green">mdi-leaf</v-icon>
          Producción y Venta Agrícola
        </div>
      </v-col>

      <v-col cols="12" class="pb-3">
        <div class="text-h6">1. Agrega una nueva Siembra</div>
        <div class="text-h7">
          Presiona el botón para agregar una producción agrícola de Verduras,
          Frutas, Granos, Raices, etc
        </div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/cosecha" depressed class="primary">
          <v-icon left>mdi-plus</v-icon>
          <span class="emoji mr-2" aria-hidden="true">🌽</span>
          <span>Agrega Nueva Siembra</span>
        </v-btn>
      </v-col>

      <v-col cols="12" class="tt">
        <div class="text-h6">
          <v-icon large color="#FF9800">mdi-carrot</v-icon> 2. Mis Cosechas y
          Ventas
        </div>
        <div class="text-h8">
          Presiona la producción de una Parcela para agregar cosechas, Ventas o
          modificarlas
        </div>
      </v-col>
      <!-- Fila de espaciado -->
      <v-col cols="12" class="py-5"></v-col>
      <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->
      <!-- Mensaje si no hay fincas -->
      <v-col v-if="Object.keys(grupos).length === 0" cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ninguna producción agrícola
        </div>
      </v-col>
      <!-- Listado de cosechas ANTES :key="grupo.group_id"
              -->
      <v-col cols="12" class="lista">
        <v-list three-line>
          <template v-for="grupo in grupos">
            <form-card
              :key="`${grupo.id_productor}_${grupo.id_finca}_${grupo.id_parcela}_${grupo.fecha}`"
              :top-text="`Finca: ${getNombreDeFinca(grupo.id_finca)}`"
              :middle-text="`Número de Finca: ${grupo.id_finca}`"
              :bottom-text="`Parcela: ${getNombreDeParcela(
                grupo.id_parcela
              )} - RUC: ${getRucDeFinca(grupo.id_finca)}`"
              :top-right-text="grupo.fecha"
              :bottom-right-text="`Productor: ${grupo.id_productor}`"
              :sincronized="grupo.sincronizado"
              @click="traerRegistroYNavegar(grupo)"
            />
          </template>

          <!--    :bottom-right-text="producerDescription(grupo.productor)"
              :sincronized="grupo.sincronizado" -->
        </v-list>
      </v-col>
      <!--     <div>
     <h1>Grupos de Preparación</h1>
         <ul>
      <li v-for="grupo in grupos" :key="grupo.grupo_id">
        <h3>Grupo ID: {{ grupo.grupo_id }}</h3>
        <p>Productor: {{ grupo.id_productor }}</p>
        <p>Fecha: {{ grupo.fecha_preparacion }}</p>
        <p>Finca: {{ grupo.id_finca }}</p>
        <p>Parcela: {{ grupo.id_parcela }}</p>
        <p>Registros: {{ grupo.registros_ids }}</p>
      </li>
     </ul>
     </div> -->
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  data() {
    return {
      grupos: [],
    }
  },
  name: 'Cosechas',
  computed: {
    //...mapState('registros', ['grupos']),
    ...mapGetters('listados', ['cultivo']),
    ...mapGetters('registros', [
      'getNombreDeFinca',
      'getNombreDeParcela',
      'productor_actual',
      'getRucDeFinca',
    ]),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  async mounted() {
    this.$store.commit('ui/updateToolbar', 'Producciones Agricolas')
    await this.fetchGrupos()
  },
  methods: {
    producerDescription,

    async traerRegistroYNavegar(grupo) {
      const { id, id_productor, id_finca, id_parcela, fecha } = grupo
      this.$router.push(
        `/ru/cosecha/${id}/${id_productor}/${id_finca}/${
          id_parcela || 'null'
        }/${fecha}`
      )
    },

    async fetchGrupos() {
      //ahora le pongo lo de productor_actual  ...mapGetters('registros', ['productor_actual',
      try {
        const productormio = this.productor_actual
        //this.$store.state.registros.productor
        if (!productormio) {
          //alert("No hay productor cargado.")
          return
        }
        const id_productor = productormio

        // Obtener la fecha actual
        //aqui se asigna el rando de fechas desde y hasta para traer las producciones
        const actual = new Date()
        const hasta = actual.toISOString().split('T')[0]
        // Obtener la fecha de hace 36 meses
        actual.setMonth(actual.getMonth() - 36)
        const desde = actual.toISOString().split('T')[0]

        const { status, data } = await this.$store.dispatch(
          'registros/listarAgricolas',
          {
            id_productor,
            fecha: '',
            id_finca: '',
            id_parcela: '',
            fechaproddesde: desde,
            fechaprodhasta: hasta,
          }
        )

        if (data) {
          this.grupos = data.map((g) => ({
            ...g, // copiamos todo lo que ya tiene el grupo
            id: g.idCosechaPrincipal || null, //el nuevo id
          }))
        } else {
          console.warn('No se recibieron datos válidos:', data)
        }
      } catch (error) {
        console.error('Error al obtener grupos:', error)
      }
    },
  },
}
</script>
<style>
.emoji {
  font-size: 1.6rem; /* súbele si quieres más grande */
  line-height: 1; /* evita que “estire” el botón */
  display: inline-block;
  transform: translateY(1px); /* micro-ajuste vertical opcional */
}
.tt {
  margin-top: 40px;
  margin-bottom: -20px;
}
.lista {
  margin-top: 20px;
}
</style>